import React, { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';
import { Loader2, Trash2, Plus } from 'lucide-react';

const COLORS = ['#c0392b', '#e67e22', '#f1c40f', '#27ae60', '#2980b9', '#8e44ad', '#e84393'];
const inputCls = 'bg-[#0d0d0f] border border-white/10 text-white text-sm px-3 py-2 focus:border-primary/60 outline-none';

export default function CustomerTagManager() {
  const qc = useQueryClient();
  const [form, setForm] = useState({ key: '', label: '', color: COLORS[0] });

  const { data: tags = [], isLoading } = useQuery({
    queryKey: ['customer-tags'],
    queryFn: () => base44.entities.CustomerTag.list('sort_order', 200),
  });

  const create = async (e) => {
    e.preventDefault();
    if (!form.key || !form.label) return;
    const key = form.key.toLowerCase().replace(/[^a-z0-9_]/g, '_');
    await base44.entities.CustomerTag.create({ key, label: form.label, color: form.color, active: true, sort_order: 0 });
    qc.invalidateQueries({ queryKey: ['customer-tags'] });
    setForm({ key: '', label: '', color: COLORS[0] });
  };

  const remove = async (t) => {
    await base44.entities.CustomerTag.delete(t.id);
    qc.invalidateQueries({ queryKey: ['customer-tags'] });
  };

  return (
    <div className="border border-white/5 bg-[#111115] p-5">
      <p className="text-primary text-[10px] font-bold tracking-widest mb-4">TAG DEFINITIONS</p>
      {isLoading ? (
        <Loader2 className="w-4 h-4 animate-spin text-white/40" />
      ) : tags.length === 0 ? (
        <p className="text-white/30 text-xs mb-4">No tags yet.</p>
      ) : (
        <div className="flex flex-wrap gap-2 mb-5">
          {tags.map((t) => (
            <span key={t.id} className="inline-flex items-center gap-1.5 text-[10px] font-bold tracking-wider px-2.5 py-1 border" style={{ color: t.color, borderColor: t.color + '55' }}>
              {t.label} <span className="text-white/20">·{t.key}</span>
              <button onClick={() => remove(t)} className="hover:text-red-400"><Trash2 className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
      <form onSubmit={create} className="flex flex-col sm:flex-row gap-2 items-end">
        <input value={form.key} onChange={(e) => setForm((f) => ({ ...f, key: e.target.value }))} placeholder="key" className={inputCls + ' flex-1'} />
        <input value={form.label} onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))} placeholder="Label" className={inputCls + ' flex-1'} />
        <div className="flex gap-1.5">
          {COLORS.map((c) => (
            <button type="button" key={c} onClick={() => setForm((f) => ({ ...f, color: c }))} className={`w-6 h-6 border ${form.color === c ? 'border-white' : 'border-transparent'}`} style={{ background: c }} />
          ))}
        </div>
        <button type="submit" className="bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-wider px-4 py-2 flex items-center gap-1.5">
          <Plus className="w-3.5 h-3.5" /> CREATE
        </button>
      </form>
    </div>
  );
}